import React from 'react'
import { Box, Flex, Text, Link } from "@chakra-ui/react";
import { motion } from "framer-motion";

const Projects = () => {
  return (
    <Box p={4}>
      <motion.div
        className="box"
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          duration: 0.8,
          delay: 0.5,
          ease: [0, 0.71, 0.2, 1.01],
        }}
      >
        <Flex alignContent={'center'} justifyContent='center'>
    <Box style={{maxWidth:'780px'}} p={4}>
    <Text as='b' fontSize={{ base: '5xl', sm: '3xl', md: '4xl' }}>
        Projects
      </Text>
      <hr style={{marginTop:'20px',marginBottom:'20px'}}/>
      <br/>
      <Text fontSize={{ base: '2xl', sm: 'xl', md: 'xl' }} textAlign={'justify'}>
      Here, are some of my past projects</Text>
      <br/>
      <Text fontSize={{ base: '2xl', sm: 'xl', md: 'xl' }} textAlign={'justify'}>
      Here, are some of my past projects</Text>
      <br/>
      
    </Box>
    </Flex>
      </motion.div>
    </Box>
  )
}

export default Projects